import React from 'react';
import { graphql, usePreloadedQuery, type EntryPointProps } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { useCurrentUser } from '@atlassian/jira-platform-services-user-current/src/main.tsx';
import { IdentityUserAri } from '@atlassian/ari/identity/user';
import type { JswExpandableProjectRefactoredQuery } from './__generated__/JswExpandableProjectRefactoredQuery.graphql';
import { JswBoardsRefactored } from './jsw-boards/JswBoardsRefactored.tsx';

type Queries = { projects: JswExpandableProjectRefactoredQuery };

export default function JswExpandableProjectRefactoredQuery({
	queries: { projects },
}: EntryPointProps<Queries, {}, EntryPointRouteParams, {}>) {
	const {
		data: {
			user: { accountId },
		},
	} = useCurrentUser();
	const ownerAri = IdentityUserAri.create({ userId: accountId || 'UNKNOWN' }).toString();
	const data = usePreloadedQuery<JswExpandableProjectRefactoredQuery>(
		graphql`
			query JswExpandableProjectRefactoredQuery(
				$cloudId: ID!
				$projectKey: String!
				$noOfBoardsToFetch: Int!
				$entityAri: ID!
				$ownerAri: ID!
			) @preloadable {
				...JswBoardsRefactored
					@arguments(
						cloudId: $cloudId
						projectKey: $projectKey
						noOfBoardsToFetch: $noOfBoardsToFetch
						entityAri: $entityAri
						ownerAri: $ownerAri
					)
			}
		`,
		projects,
	);

	// Extract the variables from the query reference
	const { cloudId, entityAri } = projects.variables;

	return (
		<JswBoardsRefactored
			queryRef={data}
			cloudId={cloudId}
			entityAri={entityAri}
			ownerAri={ownerAri}
		/>
	);
}
